export enum ERROR_CODES {
  InvalidToken = 'token_not_valid',
}
